/**
 * Initial tags data for the tags store.
 *
 * Default tags for categorizing tracks and notes.
 */
const initialTagsData = [
  { name: 'Vacation' },
  { name: 'Training' },
  { name: 'Commute' },
  { name: 'Exploration' },
  { name: 'Race' }
];

export default initialTagsData;
